import isFQDN from "validator/es/lib/isFQDN";
import isIP from "validator/es/lib/isIP";
import { route } from "../../../../shim/jsbridge";
import { isValidHttpUrl } from "../../../../utils";

type NtiLocation = {
  routeName: string;
  value: string;
};

enum ntiRoutes {
  URL = "network_url_summary",
  IP = "network_ip_summary",
  DOMAIN = "network_domain_summary"
}

const getNtiType = (
  fileName: string,
  proposedFileName?: string
): NtiLocation => {
  if (!fileName && !proposedFileName) {
    return { routeName: "", value: "" };
  }
  if (isFQDN(fileName)) {
    return { routeName: ntiRoutes.DOMAIN, value: fileName };
  }
  if (isIP(fileName)) {
    return { routeName: ntiRoutes.IP, value: fileName };
  }
  if (isValidHttpUrl(fileName)) {
    return { routeName: ntiRoutes.URL, value: fileName };
  }
  if (proposedFileName) {
    return getNtiType(proposedFileName);
  }
  return { routeName: "", value: "" };
};

export const getNtiUrl = (fileName: string, proposedFileName?: string) => {
  const { routeName, value } = getNtiType(fileName, proposedFileName);
  if (routeName && value) {
    return route(routeName, [encodeURIComponent(value)]);
  }
  return "";
};
